import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/LoginView.vue"),
  },
  {
    path: "/home",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/HomeView.vue"),
  },
  {
    path: "/build-pack",
    name: "build-pack",
    component: () =>
      import(/* webpackChunkName: "build-pack" */ "../views/BuildPackView.vue"),
  },
  {
    path: "/config-site",
    name: "config",
    component: () =>
      import(/* webpackChunkName: "config" */ "../views/ConfigView.vue"),
  },
  {
    path: "/config-layout",
    name: "config-layout",
    component: () =>
      import(/* webpackChunkName: "config-layout" */ "../views/ConfigLayoutView.vue"),
  },
  {
    path: "/salesforce/callback",
    name: "callback",
    component: () =>
      import(/* webpackChunkName: "callback" */ "../views/CallbackView.vue"),
  },  
  {
    path: "/success",
    name: "success",
    component: () =>
      import(/* webpackChunkName: "success" */ "../views/SuccessView.vue"),
  },
  {
    path: "/404",
    name: "Page404",
    component: () =>
      import(/* webpackChunkName: "page-404" */ "../views/404View.vue"),
  },
  {
    path: "*",
    redirect: "/404",
  },
];

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash, behavior: "smooth" };
    } else {
      window.scrollTo(0, 0);
    }
  },
});

export default router;
